import { colorConstants } from 'config/colorConstants';

export const TrendArrowUp = ({ className = '', color = colorConstants.limeGreen }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" className={className}>
        <path d="M8 12.6666V3.33325M8 3.33325L3.33333 7.99992M8 3.33325L12.6667 7.99992" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

export default TrendArrowUp;

